module.exports = __webpack_public_path__ + "img/spin_btn.95a4f989.png";